import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {BuilderTemplatesService} from "./builder-templates.service";
import {filter, first} from "rxjs/operators";

@Injectable()
export class LastImportedTemplateResolver implements Resolve<null> {

  constructor(
    private _builderTemplatesService: BuilderTemplatesService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const websiteId: number = route.parent.data['website'].id;
      this._builderTemplatesService.getLastBuilderTemplate(websiteId)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((lastImportedTemplate): void => {
          if (lastImportedTemplate) {
            resolve(lastImportedTemplate.data);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
